import { FAIL, LOADING, OVERWRITE, STALE } from 'reducers/default'

export const creativeActions = {
  headlineUpdate: 'HEADLINE_UPDATE',
  bodyUpdate: 'BODIES_UPDATE',
  bodyHeadlineUpdate: 'BODY_HEADLINE_UPDATE',
  urlUpdate: 'URL_UPDATE',
  mediaUpdate: 'MEDIA_UPDATE',
  mediaAndPlacementUpdate: 'MEDIA_AND_PLACEMENT_UPDATE',
  descriptionUpdate: 'DESCRIPTION_UPDATE',
  callToActionUpdate: 'CTA_UPDATE',
  audienceUpdate: 'AUDIENCE_UPDATE',
  cocreateLanguageUpdate: 'COCREATE_LANGUAGE_UPDATE',
  localizationsUpdate: 'LOCALIZATIONS_UPDATE',
  changeMainLanguage: 'CHANGE_MAIN_LANGUAGE',
  carouselCardsSet: 'CAROUSEL_CARDS_SET',
  switchToCarousel: 'SWITCH_TO_CAROUSEL',
  carouselLanguageUpdate: 'CAROUSEL_LANGUAGE_UPDATE',
  idle: 'IDLE',
}

export function creativeFormReducer(state, action) {
  switch (action.type) {
    case LOADING:
      return {
        success: false,
        loading: !state.loading,
        error: false,
        stale: state.stale,
        content: state.content,
      }
    case OVERWRITE:
      return {
        success: true,
        loading: false,
        error: false,
        stale: false,
        content: { ...action.payload },
      }
    case creativeActions.idle:
      return {
        success: true,
        loading: false,
        error: false,
        stale: false,
        content: action.payload ?? state.content,
      }
    case FAIL:
      return {
        success: false,
        loading: false,
        error: true,
        stale: false,
        message: action.payload ? action.payload : 'common.genericError',
        content: state.content,
      }
    case STALE:
      return {
        ...state,
        stale: true,
      }
    case creativeActions.headlineUpdate: {
      let headline = [...state.content.headline]
      if (action.payload === null) headline.splice(action.index, 1)
      else if (typeof action.index !== 'undefined' && action.index != null) headline[action.index] = action.payload
      else headline = action.payload

      return {
        ...state,
        content: { ...state.content, headline },
      }
    }
    case creativeActions.bodyUpdate: {
      let body = [...state.content.body]
      if (action.payload === null) body.splice(action.index, 1)
      else if (typeof action.index !== 'undefined' && action.index != null) body[action.index] = action.payload
      else body = action.payload

      return {
        ...state,
        content: { ...state.content, body },
      }
    }
    case creativeActions.bodyHeadlineUpdate: {
      let body = action.payload?.body ?? [...state.content.body]
      let headline = action.payload?.headline ?? [...state.content.headline]
      let description = action.payload?.description?.[0] ?? state.content.description

      return {
        ...state,
        content: { ...state.content, body, headline, description },
      }
    }
    case creativeActions.urlUpdate: {
      const destination_url = [...state.content.destination_url]
      if (action.payload === null) destination_url.splice(action.index, 1)
      else destination_url[action.index] = action.payload

      return {
        ...state,
        content: { ...state.content, destination_url },
      }
    }
    case creativeActions.mediaUpdate: {
      return {
        ...state,
        content: { ...state.content, media: action.payload },
      }
    }
    case creativeActions.mediaAndPlacementUpdate: {
      const { media, placement_media } = action.payload
      return {
        ...state,
        content: { ...state.content, media, placement_media },
      }
    }
    case creativeActions.descriptionUpdate: {
      return {
        ...state,
        content: { ...state.content, description: action.payload },
      }
    }
    case creativeActions.callToActionUpdate: {
      return {
        ...state,
        content: { ...state.content, call_to_action: action.payload },
      }
    }
    case creativeActions.audienceUpdate: {
      const payload = action.payload
      const update = {
        ...state.content,
        audience_id: payload?.audience_id ?? payload ?? '',
        saved_audience_id: payload?.saved_audience_id ?? '',
      }
      return {
        ...state,
        content: update,
      }
    }
    case creativeActions.cocreateLanguageUpdate: {
      return {
        ...state,
        content: { ...state.content, language: action.payload },
      }
    }
    case creativeActions.localizationsUpdate: {
      return {
        ...state,
        content: { ...state.content, localizations: action.payload },
      }
    }
    case creativeActions.changeMainLanguage: {
      const { newMainLanguage, newMainLocalization, updatedLocalizations } = action.payload
      return {
        ...state,
        content: {
          ...state.content,
          language: newMainLanguage,
          body: newMainLocalization.bodies || ['', '', ''],
          headline: newMainLocalization.headlines || ['', '', ''],
          description: newMainLocalization.description || '',
          localizations: updatedLocalizations,
        },
      }
    }
    case creativeActions.carouselCardsSet: {
      return {
        ...state,
        content: { ...state.content, carousel_cards: action.payload || [] },
      }
    }
    case creativeActions.switchToCarousel: {
      return {
        ...state,
        content: {
          ...state.content,
          media: [],
          placement_media: [],
          headline: [],
          description: '',
          localizations: {},
        },
      }
    }
    case creativeActions.carouselLanguageUpdate: {
      return {
        ...state,
        content: { 
          ...state.content,
          language: action.payload,
        },
      }
    }
    default:
      return state
  }
}
